import { Injectable } from '@angular/core';
import { AppHttpClient } from '../api.interceptor';
import { environment } from '@env/environment';
import { HelpersService } from '@base/shared/services/helpers.service';

@Injectable()
export class CompaniesRequests {
  private config = environment;

  constructor(
    private http: AppHttpClient,
    private helpers: HelpersService
  ) {
  }

  /**
   * Get list of trades
   * @param payload
   */
  getCompanies(payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.companies}${query}`;
    return this.http.get(url);
  }

  /**
   * Get list of global trades
   * @param payload
   */
  getGlobalTrades(payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.globalTrades}${query}`;
    return this.http.get(url);
  }

  /**
   * Create a company
   */
  createCompany(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.companies}`;
    return this.http.post(url, payload);
  }

}
